import { render, staticRenderFns } from "./attach-customer.vue?vue&type=template&id=013aa59c&scoped=true&"
import script from "./attach-customer.vue?vue&type=script&lang=js&"
export * from "./attach-customer.vue?vue&type=script&lang=js&"
import style0 from "./attach-customer.vue?vue&type=style&index=0&id=013aa59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013aa59c",
  null
  
)

export default component.exports